/**
 * Component for our Graph on the volume of overall Returns.
 * 
 * @component
 */

import React from "react";
import VolumeGraph from "../VolumeGraph";


const exportHeaders = [
  {
    label: 'Volume',
    value: 'volume',
    key: 'volume',
  },
  {
    label: 'Date',
    value: 'date',
    key: 'date',
  }
];
class ReturnVolume extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <VolumeGraph
        url="/api/analytics/return-volume-by-date"
        title="Return Volume"
        tab="Returns"
        tooltip="Shows the number of Returns requested per day."
        config={{
          xField: "date",
          yField: "volume",
          xAxis: { tickCount: 5 },
          yAxis: { tickInterval: 1 },
          shapeField: 'smooth'
        }}
        exportHeaders={exportHeaders}
        startDate={this.props.startDate}
        endDate={this.props.endDate}
        updateDate={this.props.updateDate}
      />
    );
  }
}

export default ReturnVolume;
